import { Button, Paper } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { IconLibrary } from '@product-framework/index';

function FooterNavigation({ currentIndex, stepperTabs, onChange }) {
  let prevConfig = null;
  let nextConfig = null;
  if (currentIndex > 0) {
    prevConfig = stepperTabs[currentIndex - 1];
  }
  if (currentIndex < stepperTabs.length) {
    nextConfig = stepperTabs[currentIndex + 1];
  }

  if (prevConfig && !prevConfig?.Icon) {
    throw new Error(
      `Icon is undefined for ${stepperTabs[currentIndex - 1]?.id}`,
    );
  }
  if (nextConfig && !nextConfig?.Icon) {
    throw new Error(
      `Icon is undefined for ${stepperTabs[currentIndex + 1]?.id}`,
    );
  }

  return (
    <Paper elevation={0} sx={{ pt: 1, pb: 1, mt: -0.5, px: 2 }}>
      <Grid2 container>
        {currentIndex > 0 ? (
          <Grid2 xs={6}>
            <Button
              variant="outlined"
              endIcon={<prevConfig.Icon />}
              startIcon={<IconLibrary.Previous />}
              color="tertiary"
              onClick={() => onChange(currentIndex - 1)}>
              {prevConfig.label}
            </Button>
          </Grid2>
        ) : (
          <Grid2 xs={6}>&nbsp;</Grid2>
        )}
        {currentIndex < stepperTabs.length - 1 && (
          <Grid2 xs={6} textAlign="right">
            <Button
              variant="outlined"
              startIcon={<nextConfig.Icon />}
              endIcon={<IconLibrary.Next />}
              color="tertiary"
              onClick={() => onChange(currentIndex + 1)}>
              {nextConfig.label}
            </Button>
          </Grid2>
        )}
      </Grid2>
    </Paper>
  );
}

export default FooterNavigation;
